// /b/:id/history — last 7 days at a glance.

import { useOutletContext } from "react-router-dom";
import type { BabyShellContext } from "./BabyShell";
import { HistoryView } from "../components/HistoryView";

export function History() {
  const { baby, events: eventsApi } = useOutletContext<BabyShellContext>();
  return <HistoryView babyId={baby.id} events={eventsApi.events} />;
}
